<template>
  <div class="student-detail">
    <div class="left-box">
      <div :class="{'pic':true,'girl':studentForm.sex==0}">
        <img :src="picSrc" alt="" srcset="">
      </div>
      <div class="name">{{studentForm.name}}</div>
      <div class="company">{{studentForm.company}}</div>
      <div class="project-info">
        <div class="project-num">
          <div class="num">{{projectList.length}}</div>
          <div class="total">项目总数</div>
        </div>
        <div class="project-days">
          <div class="num">{{days}}</div>
          <div class="total">加入学院天数</div>
        </div>
      </div>
      <div class="remark-box">
        <span>简介</span>
        <div class="remark-text">
          {{studentForm.remark}}
        </div>
      </div>
      <div class="link-box">
        <div class="link">联系方式</div>
        <div class="link-item"><i class="el-icon-mobile-phone"></i> <span>{{studentForm.linkPhone}}</span> </div>
        <div class="link-item email"><i class="el-icon-message"></i>{{studentForm.email}}</div>
        <div class="link-item cart-no"><i class="el-icon-postcard"></i>{{studentForm.cartNo}}</div>
      </div>
    </div>
    <div class="cart">

      <div class="base-info">
        <div class="title"> <span>个人信息</span> </div>
        <div class="base-box">

          <el-row type="flex">
            <el-col>姓名</el-col>
            <el-col>{{studentForm.name}}</el-col>
            <el-col>单位</el-col>
            <el-col>{{studentForm.company}}</el-col>
            <el-col>学科</el-col>
            <el-col>{{studentForm.subject}}</el-col>
          </el-row>

          <el-row type="flex">
            <el-col>学历</el-col>
            <el-col>{{studentForm.education}}</el-col>
            <el-col>地区</el-col>
            <el-col>{{studentForm.addr}}</el-col>
            <el-col>职位</el-col>
            <el-col>{{studentForm.job}}</el-col>
          </el-row>

        </div>
      </div>
      <div class="base-info">
        <div class="title"> <span>项目经历</span> </div>
        <div class="info-box">
          <el-empty description="暂无相关内容" v-if="!projectList.length" :image="require('../../assets/img/not-content.png')" :image-size="300"></el-empty>
          <div class="project-list" v-else>
            <div class="project-item" v-for="(project ,index ) in projectList" :key="index" @click="goDetail(project.id)">
              <div class="project-title">
                <img src="../../assets/img/file.png" alt="" srcset="">
                <span>{{project.name}}</span>
              </div>
              <!-- <div class="connent">评价:{{project.comment}}</div> -->
            </div>

          </div>
        </div>

        <div class="base-info">
          <div class="title"> <span>相关文件</span> </div>
          <div class="info-box">
            <el-empty description="暂无相关内容" v-if="!fileList.length" :image="require('../../assets/img/not-content.png')" :image-size="300"></el-empty>
            <div class="upload-area" v-else>

              <div class="file" v-for="(file,index) in fileList " :key="index">
                <div class="file-left" @click="handlePreview(file)">
                  <img v-if="file.suffName.indexOf('xls')>-1" src="../../assets/img/xls.png" alt="" srcset="">
                  <img v-else-if="file.suffName.indexOf('ppt')>-1" src="../../assets/img/ppt.png" alt="" srcset="">
                  <img v-else-if="file.suffName.indexOf('pdf')>-1" src="../../assets/img/pdf.png" alt="" srcset="">
                  <img v-else-if="['rar','zip'].includes(file.suffName)" src="../../assets/img/zip.png" alt="" srcset="">
                  <img v-else-if="['bmp','gif','jpeg','png','jpg'].includes(file.suffName)" src="../../assets/img/jpg.png" alt="" srcset="">
                  <img v-else src="../../assets/img/doc.png" alt="" srcset="">
                  <span class="file-name">{{file.fileName}}</span>
                </div>
                <div class="tags">
                  <el-tag v-if="file.tag" size="small" type='danger' effect="dark" :closable='false' :disable-transitions="false">
                    {{file.tag}}
                  </el-tag>
                </div>
                <!-- <i class="el-icon-circle-check"></i> -->
                <el-button type="primary" size="mini" @click="download(file)"><i class="el-icon-download"></i>下载</el-button>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <preview-box ref="preview"></preview-box>
  </div>
</template>

<script>
import commonData from '../../common/commonData'
import * as resourceApi from '../../api/resourceAPI'
import * as fileApi from '../../api/fileAPI'
import * as projectApi from '../../api/projectAPI'
import moment from 'moment'
import previewBox from '../subcomponents/preview.vue'


const validatorPhone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('手机号不能为空'))
  } else if (!/^1\d{10}$/.test(value)) {
    callback(new Error('手机号格式错误'))
  } else {
    callback()
  }
}
export default {
  components: {
    previewBox
  },
  props: {

  },
  data() {
    return {
      studentForm: {},
      stageMap: {},
      subjectMap: {},
      fileList: [],
      projectList: [],
      picSrc: '',
      days: 0
    };
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.stageMap = commonData.stage
    this.subjectMap = commonData.subject

  },
  async mounted() {
    await this.qryMaster()
    await this.qryFileList()
    await this.qryProjectList()
    var start = moment(this.studentForm.createTime).format('YYYY-MM-DD')
    var end = moment(new Date()).format('YYYY-MM-DD')
    this.days = moment(end).diff(start, 'day')
  },
  methods: {
    async qryMaster() {
      let id = this.$route.params.id
      let param = { name: 'tb_student' }
      param.where = [{ filed: 'id', type: 'eq', value: id }]
      let res = await resourceApi.list(param)
      if (res.flag) {
        this.studentForm = res.data.list[0]
        this.oldForm = { ...this.studentForm }
        if (this.studentForm.userPic) {

          this.picSrc = "http://" + window.location.hostname + "/userpic/" + this.studentForm.userPic
        }
      }

    },
    async qryFileList() {
      let id = this.$route.params.id
      let param = { name: 'bs_file' }
      param.where = [{ filed: 'busiId', type: 'eq', value: id }, { filed: 'type', type: 'eq', value: '3' }]
      let res = await resourceApi.list(param)
      if (res.flag) {
        this.fileList = res.data.list

      }

    },
    async qryProjectList() {
      let id = this.$route.params.id
      let param = { memberId: id, memberType: '0' }
      let res = await projectApi.projectMemberList(param)
      if (res.flag) {
        this.projectList = res.data


      }

    },



    async handlePreview(file) {
      let fileName = file.fileName
      let uuid = file.uuid
      let suffName = fileName.substring(fileName.lastIndexOf('.') + 1)
      console.log('预览pdf', fileName, suffName)
      let offices = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
      let imgs = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
      if (!offices.includes(suffName) && !imgs.includes(suffName) && 'txt' != suffName) {

        return
      }
      let res = await fileApi.preview({ uuid, suffName, fileName, type: 'student' })
      console.log("handlePreview", suffName);
      if (offices.includes(suffName)) {
        let blob = new Blob([res], { type: 'application/pdf' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.fileSrc = href
        // this.src = `./pdf/web/viewer.html?file=${encodeURIComponent(href)}`
        //window.open(`./pdf/web/viewer.html?file=${encodeURIComponent(href)}`);
        //this.src = this.getObjectURL(res)
        this.$refs.preview.fileVisible = true
      } else if (imgs.includes(suffName)) {
        let blob = new Blob([res])
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.imgSrc = href
        this.$refs.preview.imgVisible = true
      } else if ('txt' == suffName) {
        console.log('txt', res);
        let blob = new Blob([res], { type: 'text/plain' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.fileSrc = href
        this.$refs.preview.fileVisible = true

      }
    },
    download(file) {
      fileApi.download({ type: 'master', fileName: file.fileName, uuid: file.uuid }).then(res => {
        const link = document.createElement('a');
        let blob = new Blob([res]);
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);

        link.setAttribute('download', file.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)

      })

    },
     goDetail(id) {
      this.$router.push("/projectdetail/" + id);
    },
  },
};
</script>

<style  lang="less">
.student-detail {
  overflow-x: hidden;
  display: flex;
  width: 100%;
  .left-box {
    width: 240px;
    background: #fff;
    // height: calc(100hv);
    margin-right: 20px;
    border-radius: 10px;
    text-align: center;
    padding: 20px;
    flex-shrink: 0;
    .pic {
      position: relative;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50px;
        display: block;
        margin: 20px auto;
      }
      &::before {
        content: "";
        width: 20px;
        height: 20px;
        position: absolute;
        background: url("../../assets/img/boy.png");
        background-size: 100%;
        bottom: 0px;
        right: 65px;
      }
    }
    .pic.girl {
      &::before {
        background: url("../../assets/img/girl.png");
      }
    }
    .name {
      font-size: 16px;
      color: #080a26;
    }
    .company {
      margin-top: 10px;
      color: #3c4353;
      font-size: 14px;
    }
    .project-info {
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      border-radius: 8px;
      background: #e8edff;
      padding: 20px;
      .num {
        font-size: 24px;
        color: #2257e8;
      }
      .total {
        font-size: 12px;
        color: #21304f;
      }
    }
    .remark-box {
      text-align: left;
      margin-top: 20px;
      font-size: 14px;
      color: #3c4353;
      .remark-text {
        margin-top: 20px;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        min-height: 60px;
      }
    }
    .link-box {
      text-align: left;
      margin-top: 20px;
      font-size: 14px;
      color: #3c4353;
      .link-item {
        margin-top: 30px;
        i {
          background: #29cccc;
          color: #fff;
          width: 30px;
          height: 30px;
          border-radius: 15px;
          text-align: center;
          line-height: 30px;
          margin-right: 30px;
        }
      }
      .email i {
        background: #1d94ff;
      }
      .cart-no i {
        background: #61cb2c;
      }
    }
  }
  .cart {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    // width: calc(100vw - 260px);
    flex-grow: 1;
  }
  .base-info {
    .title {
      padding-bottom: 20px;
      border-bottom: 1px solid #dddddd;
      margin-bottom: 20px;
      > span {
        display: block;
        padding-left: 20px;
        position: relative;
        &::before {
          position: absolute;
          content: "";
          width: 4px;
          height: 20px;
          background: #346aff;
          opacity: 1;
          display: block;
          left: 0px;
          top: 1px;
        }
      }
    }
    .base-box {
      .el-row {
        color: #3c4353;
        font-size: 12px;

        border-right: 1px solid #dedede;
        .el-col {
          border-top: 1px solid #dedede;
          border-left: 1px solid #dedede;
          padding: 10px 20px;
        }
        .el-col:nth-child(2n-1) {
          background: #f8f9fb;
          text-align: center;
          max-width: 80px;
          padding: 10px 0px;
        }
      }
      .el-row:last-child {
        border-bottom: 1px solid #dedede;
      }
    }
    .project-list {
      padding-bottom: 20px;
      display: flex;
      flex-wrap: wrap;
      .project-item {
        border: 1px solid #dedede;
        min-width: 200px;
        max-width: 320px;
        margin-bottom: 20px;
        margin-right: 20px;
        border-radius: 5px;
        background: #f7f8f9;
        padding: 20px;
        .project-title {
          display: flex;
          align-items: center;
          color: #303133;
          img {
            width: 20px;
            margin-right: 10px;
          }
        }
        .connent {
          margin-top: 10px;
          color: #909399;
          font-size: 14px;
        }
      }
    }
  }
  .base-info + .base-info {
    margin-top: 20px;
    position: relative;
  }

  .upload-area {
    padding: 20px;
    border: 1px solid #dfdfe1;
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .ext-info {
      font-size: 12px;
      color: #a6aab8;
      padding: 20px 0;
      margin: 0;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .file-left {
        cursor: pointer;
        display: flex;
        align-items: center;
        width: 240px;

        img {
          width: 16px;
        }
        .file-name {
          margin-left: 10px;
          font-size: 13px;
          color: #606266;
        }
      }

      > .el-icon-close {
        font-size: 18px;
        cursor: pointer;
        color: #606266;
      }
    }
    .file + .file {
      margin-top: 10px;
    }
  }
}
</style>
